export const displyWalletAddress = (address) => {
  if (address) {
    const firstFive = address.substr(0, 5);
    const lastFive = address.substr(-4);
    return `${firstFive}...${lastFive}`;
  }
};
